import React from 'react';

import withCard from './WithCard';
import Date from '../../../Types/Components/Date';

const DateCard = (props) => {
  return <Date {...props} />
}

export default withCard(DateCard);